// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gTbprD2tkDuTQBh6gTSK:hover{background-color:var(--mu-superficie-escura, #CCC)}`, "",{"version":3,"sources":["webpack://./Scripts/app/components/selecao-com-filtro/selecao-com-filtro.module.scss"],"names":[],"mappings":"AACI,4BACI,kDAAA","sourcesContent":[".itemSelecao {\r\n    &:hover {\r\n        background-color: var(--mu-superficie-escura, #CCC);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"itemSelecao": `gTbprD2tkDuTQBh6gTSK`
};
export default ___CSS_LOADER_EXPORT___;
